import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../components/Hero';
import LinkBox from '../components/LinkBox';

export type PITelecomProps = {};

const PITelecom: React.FC<PITelecomProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/railcrop.png'}
        heading={
          intl.formatMessage({
            id: 'public_info_5'
          })
        } 
       />
       <div className="content">
        <div className="w-full flex flex-row flex-wrap">
          <div className="w-1/2 p-2">
            <LinkBox target="_blank" href="/pdf/telecom/MCB-SMR-032 Uso de la contrasena y marca de conformidad.docx" label={
              intl.formatMessage({
                id: 'pw-usage'
              })
            } />
          </div>
          <div className="w-1/2 p-2">
            <LinkBox href="/pdf/telecom/MCB-CCP-002 Contrato general de prestacion de servicios de certificacion.docx" label={
              intl.formatMessage({
                id: 'service-contract'
              })
            } />
          </div>
          <div className="w-1/2 p-2">
          <LinkBox target="_blank" href="/pdf/telecom/MCB-DOT-040 Solicitud de certificacion para telecomunicaciones.docx" label={
              intl.formatMessage({
                id: 'telecom-application'
              })
            } />
          </div>
          <div className="w-1/2 p-2">
          <LinkBox target="_blank" href="/pdf/telecom/MCB-DOT-041 Requisitos de certificacion para Telecomunicaciones.pdf" label={
              intl.formatMessage({
                id: 'cert-reqs-tel'
              })
            } />
          </div>
          <div className="w-1/2 p-2">
          <LinkBox target="_blank" href="/pdf/telecom/MCB-DOT-049 Formato de manejo de muestras.docx" label={
              intl.formatMessage({
                id: 'sample-mgmt'
              })
            } />
          </div>
          <div className="w-1/2 p-2">
            <LinkBox target="_blank" href="/pdf/telecom/MCB-DOT-110 Lista de precios telecomunicaciones.pdf" label={
              intl.formatMessage({
                id: 'price-list'
              })
            } />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PITelecom;